module.exports = __webpack_public_path__ + "img/block-1920.4bf6b046.jpg";